import React, { useEffect, useState } from 'react';
import axios from '../../axios'; // Adjust if path differs
  import { Link } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion } from 'framer-motion';
import { 
  Timeline, 
  TimelineItem, 
  TimelineContent, 
  TimelineSeparator, 
  TimelineDot 
} from '@mui/lab';
import NecSooLoader from '../../components/NecSooLoader';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import FavoriteIcon from '@mui/icons-material/Favorite';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import SchoolIcon from '@mui/icons-material/School';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';


// First install: npm install aos framer-motion

// Styled Components
const HeroSection = styled(Box)(({ theme }) => ({
  background: '#FFFFFF',
  color: '#1E88E5',
  padding: theme.spacing(1),
  position: 'relative',
  minHeight: 'auto',
  display: 'flex',
  alignItems: 'flex-start',
  textAlign: 'center',
  marginTop: '64px',
}));


const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const Section = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
}));

// Add these new styled components
const NewsCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
  },
}));

const ContactForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

const Footer = styled(Box)(({ theme }) => ({
  background: '#1E88E5',
  color: 'white',
  padding: theme.spacing(6, 0),
  marginTop: 'auto',
}));

const Home = () => {
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const [galleryItems, setGalleryItems] = useState([]);
const [currentIndex, setCurrentIndex] = useState(0);

  const MapContainer = styled('iframe')(({ theme }) => ({
  width: '100%',
  height: '400px',
  borderRadius: theme.spacing(1),
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: 'none',
}));

  

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) => (prev + 1) % galleryItems.length);
  }, 8000); // 8 seconds

  return () => clearInterval(interval);
}, [galleryItems.length]);


  
const [selectedImage, setSelectedImage] = useState(null);

useEffect(() => {
  const fetchGalleryItems = async () => {
    try {
      const response = await axios.get('/gallery_management.php'); // Adjust endpoint as needed
      setGalleryItems(response.data);
    } catch (error) {
      console.error("Error fetching gallery data", error);
    }
  };

  fetchGalleryItems();
}, []);


  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    // Simulate loading time for animations to be ready
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Give enough time for assets to load

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <NecSooLoader size="large" />;
  }

  const features = [
    {
      title: "Promote an enabling environment",
      description: "Promotes an enabling environment for the holistic development interventions of NeCSOO members in the Oromia National Regional State.  ",
      number: "01",
    },
    {
      title: "Peace Promotion",
      description: " Promotes peace, human rights, and good governance activities in the Oromia National Regional State.",
      number: "02",
    },
    {
      title: "Advocacy",
      description: "Coordinates and support members’ engagements in the humanitarian response, development, and advocacy activities.",
      number: "03",
    },
    {
      title: "Networking",
      description: "Facilitates information exchange among member organizations on issues pertinent to members and the wider CSO sector.",
      number: "04",
    }
  ];

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh', // This ensures the footer stays at the bottom
    }}>
      <HeroSection>
        <Container maxWidth="lg">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <Typography 
              variant="h1" 
              sx={{ 
                fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3.2rem' },
                fontWeight: 700,
                letterSpacing: '-0.02em',
                mb: 1,
                pt: 1,
                textAlign: 'center',
                color: '#1E88E5',
              }}
            >
              Network of Civil Society<br />
              Organizations in Oromia
            </Typography>

            <Typography 
              variant="h5"
              sx={{ 
                maxWidth: '800px',
                mb: 1,
                textAlign: 'center',
                mx: 'auto',
                color: 'black',
                fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.2rem' },
              }}
            >
             
            </Typography>

            <Box 
              component="img"
              src="/images/geometric-handshake.png"
              alt="Geometric handshake illustration"
              sx={{
                width: '100%',
                maxWidth: '1000px',
                height: 'auto',
                maxHeight: '45vh',
                objectFit: 'contain',
                mx: 'auto',
                my: 1,
                display: 'block',
              }}
            />

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1}
              sx={{ 
                justifyContent: 'center',
                mt: 1,
              }}
            >
            

<Link to="/contact" style={{ textDecoration: 'none' }}>
  <Button 
    variant="contained"
    size="large"
    sx={{ 
      py: 1,
      px: 3,
      fontSize: '1rem',
      backgroundColor: '#1E88E5',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#1976D2',
      }
    }}
  >
    Join Our Network
  </Button>
</Link>
<Link to="/about/history" style={{ textDecoration: 'none' }}>
              <Button 
                variant="outlined"
                size="large"
                sx={{ 
                  py: 1,
                  px: 3,
                  fontSize: '1rem',
                  borderRadius: '4px',
                  borderColor: '#1E88E5',
                  color: '#1E88E5',
                  '&:hover': {
                    borderColor: '#1976D2',
                    color: '#1976D2',
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  }
                }}
              >
                Learn More
              </Button>
              </Link>
            </Stack>
          </motion.div>
        </Container>
      </HeroSection>

      <Section sx={{ bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={6} key={index}>
                <div data-aos="fade-up" data-aos-delay={index * 100}>
                  <StyledCard>
                    <CardContent sx={{ p: 4 }}>
                      <Typography 
                        variant="h1" 
                        sx={{ 
                          color: 'primary.main',
                          opacity: 0.1,
                          fontSize: '6rem',
                          position: 'absolute',
                        }}
                      >
                        {feature.number}
                      </Typography>
                      <Box sx={{ position: 'relative' }}>
                        <Typography 
                          variant="h5" 
                          gutterBottom
                          sx={{ 
                            fontWeight: 600,
                            mb: 2,
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography 
                          variant="body1"
                          sx={{ 
                            color: 'text.secondary',
                            lineHeight: 1.7,
                          }}
                        >
                          {feature.description}
                        </Typography>
                      </Box>
                    </CardContent>
                  </StyledCard>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Section>

      <Section sx={{ 
        bgcolor: '#1E88E5',
        color: 'white',
      }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={12} md={6}>
              <div data-aos="fade-right">
                <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
                  Our Impact
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem' }}>
                  Through collaboration and dedication, we've made significant 
                  strides in enabling environment for civil society organizations across Oromia.
                </Typography>
                <Link to="/programs/Promoting-Enabling-Environment" style={{ textDecoration: 'none' }}>
                <Button 
                  variant="outlined" 
                  size="large"
                  sx={{ 
                    color: 'white',
                    borderColor: 'white',
                    borderRadius: '8px',
                    textTransform: 'none',
                    '&:hover': {
                      borderColor: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    }
                  }}
                >
                  View Our Projects
                </Button>
                </Link>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                {[ 
                  { number: '40+', label: 'Member Organizations' }, 
                  { number: '5+', label: 'Projects Completed' }, 
                 
                ].map((stat, index) => (
                  <Grid item xs={6} key={index}>
                    <div data-aos="fade-up" data-aos-delay={index * 100}>
                      <Typography variant="h3" sx={{ fontWeight: 700 }}>
                        {stat.number}
                      </Typography>
                      <Typography variant="body1" sx={{ opacity: 0.8 }}>
                        {stat.label}
                      </Typography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Section>


{/* Gallery Preview Section (Replaces Latest News & Updates) */}
<Section sx={{ bgcolor: 'background.paper', py: 8 }}>
  <Container maxWidth="md">
    <Typography
      variant="h3"
      textAlign="center"
      gutterBottom
      sx={{ fontWeight: 600, mb: 4 }}
    >
      Photo Gallery
    </Typography>

    {galleryItems.length > 0 && (
      <Box sx={{ position: 'relative' }}>
        <Box
          component={motion.div}
          key={galleryItems[currentIndex]?.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          sx={{
            width: '100%',
            height: '450px',
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: 3,
          }}
        >
          <Box
            component="img"
            src={`${IMAGE_BASE_URL}/${galleryItems[currentIndex]?.image}`}
            alt={galleryItems[currentIndex]?.title || "Gallery Image"}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Left Arrow */}
        <IconButton
          onClick={() => setCurrentIndex((prev) => (prev === 0 ? galleryItems.length - 1 : prev - 1))}
          sx={{
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.7)',
            },
          }}
        >
          <ChevronLeftIcon fontSize="large" />
        </IconButton>

        {/* Right Arrow */}
        <IconButton
          onClick={() => setCurrentIndex((prev) => (prev + 1) % galleryItems.length)}
          sx={{
            position: 'absolute',
            top: '50%',
            right: 10,
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.7)',
            },
          }}
        >
          <ChevronRightIcon fontSize="large" />
        </IconButton>

        {/* Dot Pagination */}
        <Stack direction="row" justifyContent="center" spacing={1} mt={2}>
          {galleryItems.map((_, i) => (
            <Box
              key={i}
              onClick={() => setCurrentIndex(i)}
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: i === currentIndex ? '#1E88E5' : '#ccc',
                transition: '0.3s',
                cursor: 'pointer',
              }}
            />
          ))}
        </Stack>
      </Box>
    )}
  </Container>
</Section>



      {/* Programs Timeline Section */}
      <Section sx={{ bgcolor: 'grey.100' }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            textAlign="center" 
            gutterBottom
            sx={{ mb: 8, fontWeight: 600 }}
          >
            Our Programs
          </Typography>
          <Timeline position="alternate">
  {[
    {
      title: "Enabling Environment",
      description: "Creating inclusive and supportive frameworks for CSO operations",
      icon: <LocalHospitalIcon />,
      color: "#2196f3"
    },
    {
      title: "Peace Promotion",
      description: "Fostering harmony and stability through civic collaboration",
      icon: <FavoriteIcon />,
      color: "#ff9800"
    },
    {
      title: "Good Governance",
      description: "Encouraging accountability and transparency in all levels of leadership",
      icon: <VolunteerActivismIcon />,
      color: "#4caf50"
    },
    {
      title: "Research & Studies",
      description: "Generating evidence-based insights to influence policy and practice",
      icon: <SchoolIcon />,
      color: "#9c27b0"
    }
  ].map((item, index) => (
    <TimelineItem key={index}>
      <TimelineSeparator>
        <TimelineDot
          sx={{
            bgcolor: item.color
          }}
        >
          {item.icon}
        </TimelineDot>
      </TimelineSeparator>
      <TimelineContent>
        <div data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}>
          <Typography variant="h6" component="span">
            {item.title}
          </Typography>
          <Typography color="text.secondary">
            {item.description}
          </Typography>
        </div>
      </TimelineContent>
    </TimelineItem>
  ))}
</Timeline>

        </Container>
      </Section>

      {/* Contact Section */}
      <Section>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <div data-aos="fade-right">
                <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
                  Get in Touch
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Have questions about our programs or want to become a member?
                  Reach out to us!
                </Typography>
                <form 
  
  style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
>
  <TextField
    fullWidth
    label="Name"
    variant="outlined"
    name="name"
    required
  />
  <TextField
    fullWidth
    label="Email"
    variant="outlined"
    type="email"
    name="email"
    required
  />
  <TextField
    fullWidth
    label="Message"
    variant="outlined"
    multiline
    rows={4}
    name="message"
    required
  />
  <Button 
    variant="contained" 
    size="large"
    sx={{ 
      py: 1.5,
      fontSize: '1.1rem',
      textTransform: 'none',
      bgcolor: '#01B7EA',
      '&:hover': {
        bgcolor: '#0288D1',
      },
    }}
  >
    Send Message
  </Button>
</form>

              </div>
            </Grid>
            <Grid item xs={12} md={6}>
                        <Typography 
                          variant="h5" 
                          sx={{ 
                            mb: 3,
                            fontWeight: 600,
                            color: '#111827',
                            position: 'relative',
                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              bottom: -8,
                              left: 0,
                              width: 40,
                              height: 3,
                              borderRadius: 1.5,
                              backgroundColor: '#01B7EA',
                            },
                          }}
                        >
                          Visit Our Office
                        </Typography>
                        <MapContainer
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.485318144877!2d38.813496173528314!3d9.019414689141994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85000dcfb3e5%3A0x3a90eb94ef9dfa1c!2sFresh%20corner%20Gurdshola!5e0!3m2!1sen!2set!4v1740931919331!5m2!1sen!2set"
                          allowFullScreen
                          loading="lazy"
                        />
                      </Grid>
          </Grid>
        </Container>
      </Section>

      {/* Partnerships Section */}
<Section sx={{ bgcolor: 'grey.100', py: 8, overflow: 'hidden' }}>
  <Container maxWidth="lg">
    <Typography
      variant="h3"
      textAlign="center"
      gutterBottom
      sx={{
        fontWeight: 600,
        mb: 4
      }}
    >
      Our Partners
    </Typography>
    <Typography
      variant="body1"
      textAlign="center"
      sx={{
        mb: 6,
        maxWidth: '800px',
        mx: 'auto',
        color: 'text.secondary'
      }}
    >
      We collaborate with leading organizations to create lasting positive impact in our communities
    </Typography>

    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 6,
          animation: 'scrollLeft 40s linear infinite',
          '&:hover': {
            animationPlayState: 'paused',
          }
        }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            component="img"
            src={`/images/partnerships${i === 0 ? '' : i}.png`}
            alt={`Partner ${i + 1}`}
            sx={{
  height: 80,
  objectFit: 'contain',
  filter: 'grayscale(0.3)',
  transition: 'all 0.3s ease',
  transform: 'scale(1)',
  '&:hover': {
    filter: 'grayscale(0)',
    transform: 'scale(1.08)',
  }
}}

          />
        ))}
        {/* Duplicate the images to make the loop seamless */}
        {[0, 1, 2, 3, 4].map((i) => (
          <Box
            key={`repeat-${i}`}
            component="img"
            src={`/images/partnerships${i === 0 ? '' : i}.png`}
            alt={`Partner ${i + 1}`}
            sx={{
  height: 80,
  objectFit: 'contain',
  filter: 'grayscale(0.3)',
  transition: 'all 0.3s ease',
  transform: 'scale(1)',
  '&:hover': {
    filter: 'grayscale(0)',
    transform: 'scale(1.08)',
  }
}}

          />
        ))}
      </Box>
    </Box>
  </Container>

  {/* Animation keyframes */}
  <style>
    {`
      @keyframes scrollLeft {
        0% {
          transform: translateX(0%);
        }
        100% {
          transform: translateX(-50%);
        }
      }
    `}
  </style>
</Section>

    </Box>
  );
};

export default Home;
